<admin-layout
    pageTitle="Controladores"
    searchPlaceholder="Nome ou código"
    [showSearch]="true"
    (searchChange)="search = $event"
>
    <entity-crud
        #crud
        [repository]="repository"
        [entityTypes]="entityTypes"
        (entityChange)="list.invalidate()"
        [showDefaultFab]="false"
    >
        <entity-cards
            #list
            [repository]="repository"
            [perspective]="perspective"
            [searchTerm]="search"
            [summary]="true"
        >
            <mat-card
                class="entityCard admin-entity-card"
                *entityCard="let entity"
                (click)="openControllerDialog(entity)"
            >
                <div class="card-accent"></div>
                <div class="card-body">
                    <div class="info-item code">
                        <span class="info-label">Código</span>
                        <span class="info-value">{{ entity.code }}</span>
                    </div>
                    <div class="info-item name">
                        <span class="info-label">Nome</span>
                        <span class="info-value" [title]="entity.name">{{ entity.name }}</span>
                    </div>
                </div>
                <div class="card-meta">
                    <span class="chip" [class.chip-ok]="entity.active" [class.chip-off]="!entity.active">
                        {{ entity.active ? 'Ativo' : 'Inativo' }}
                    </span>
                    <span class="chip chip-muted">
                        {{ entity.producersCount ?? entity.producers?.length ?? 0 }} produtores
                    </span>
                </div>
                <div class="card-foot">
                    <span class="hint">Ver controles</span>
                    <mat-icon>chevron_right</mat-icon>
                </div>
            </mat-card>
        </entity-cards>
    </entity-crud>
</admin-layout>
